const unauthorizedEventName = "video-web:unauthorized"

export const emitUnauthorized = () => {
  if (typeof window === "undefined") return

  window.dispatchEvent(new Event(unauthorizedEventName))
}

export const subscribeUnauthorized = (handler: () => void) => {
  if (typeof window === "undefined") {
    return () => {}
  }

  window.addEventListener(unauthorizedEventName, handler)

  return () => {
    window.removeEventListener(unauthorizedEventName, handler)
  }
}
